export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hooks.hook('page:finish', () => {
    const { hash } = useRoute()
    if (hash) {
      const el = document.querySelector(`#${CSS.escape(hash.substring(1))}`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  })
})
